import { useEffect } from 'react';
import { Box, Spinner, Text } from '@chakra-ui/react';
import { useToast } from '@chakra-ui/react';
import { useSelector } from 'react-redux';
import { secureFetch } from '../data/secureFetch';

const Onboarding = () => {
  const toast = useToast();
  const uid = useSelector((state) => state.user.uid);

  useEffect(() => {
    if (!uid) {
      return;
    }
    const fetchOnboardingLink = async () => {
      try {
        const response = await secureFetch(`/api/onboarding`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          data: { uid }
        });

        if (!response.ok) throw new Error('Failed to fetch onboarding link');
        const jsonResponse = response;
        const { onboarding_link } = jsonResponse;
        // Securely redirect to onboarding link
        window.location.href = onboarding_link.link_url;
      } catch (error) {
        toast({
          title: "Error",
          description: error.message,
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      }
    };

    fetchOnboardingLink();
  }, [toast, uid]);

  return (
    <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" height="100vh">
      <Spinner size="xl" />
      <Text mt={4}>Setting up your account, please wait...</Text>
    </Box>
  );
};

export default Onboarding;
